import { Box } from "@mui/material";
import chakraImage from "../assets/chakra.png";
import { useMediaQuery, useTheme } from "@mui/material";

const ChakraImageComponent = () => {
  const theme = useTheme();
  const isMediumScreen = useMediaQuery(theme.breakpoints.down("md")); // screen size below 900px

  // Adjust size based on screen
  const height = isMediumScreen ? "300px" : "600px";
  const width = isMediumScreen ? "300px" : "600px";

  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        position: "relative",
      }}
    >
      <img
        src={chakraImage}
        alt="chakra"
        style={{
          width: width,
          height: height,
          animation: "spin 10s linear infinite",
          position: "absolute",
        }}
      />
    </Box>
  );
};

export default ChakraImageComponent;
